import{r as o}from"./resolveProps-87ac6ba3.js";function e(e){const{theme:n,name:s,props:t}=e;return n&&n.components&&n.components[s]&&n.components[s].defaultProps?o(n.components[s].defaultProps,t):t}export{e as g};
